import React, { useContext, useEffect, useState } from 'react'
import { MdOutlineWidgets } from "react-icons/md";
import event from '../assets/Event.png'
import { getAppData } from '../apiService';
import { ApiContext } from '../context/ApiContext';
import { ShimmerButton, ShimmerPostItem, ShimmerText, ShimmerThumbnail } from 'react-shimmer-effects';

function Schedule() {


  const options = { weekday: 'long', month: 'short', day: 'numeric', year: 'numeric' };
  // const FullDate =  date.toLocaleDateString('en-US', options);
  const { days, myDay, setMyDay, schedule } = useContext(ApiContext)
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);const [time, setTime] = useState('');
      const [matchl,setMatchL] = useState(null)



  // const Today = FullDate.slice(0,3);

  // console.log(myDay,"dghwst");

  const getPreviousTimeDiv = (currentTime) => {
    const currentDateTime = new Date(`1970-01-01 ${currentTime}`);
    const currentDay = new Date().toLocaleString('en-US', { weekday: 'long' }).toLowerCase();
    
// console.log(schedule);

    for (let i = schedule?.length - 1; i >= 0; i--) {
      const divTimeDate = new Date(`1970-01-01 ${schedule[i].time}`);

      if (schedule[i].day == currentDay && divTimeDate <= currentDateTime) {
        return schedule[i].id; // Return ID of the matching div
      }
    }
    return null; // If no previous time is found
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const currentTime = new Date().toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      });

        setMatchL(getPreviousTimeDiv(currentTime));

      // if (matchl) {
      //   console.log(`Matching div id: ${matchl}`);
      // } else {
      //   console.log('No matching time found.');
      // }
    }, 1000); // Check every second

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, [schedule]);




  const [scheduleDays, setScheduleDays] = useState(days.filter((item) => item.day === myDay));

  // console.log(schedule,"now");

  // const handleDayClick = (id) =>{
  //   const dayss = days.find(item =>item.id == id);
  //   const day = dayss.day;
  //   const newItem = scheduleDat.find(item=>item.day == day);
  //   if(newItem){
  //     const itContains = scheduleDays.some(item=>item.id == newItem.id);
  //     // if(!itContains){
  //     //   // scheduleDays.push(newItem)
  //     //   setScheduleDays(prev => [...prev,newItem])
  //     //   console.log("is clicked");

  //     // }
  //     if (!itContains) {
  //       // setScheduleDays(prev => {
  //       //   const updatedScheduleDays = [...prev, newItem];

  //       //   // Sort scheduleDays by the days array order
  //       //   return updatedScheduleDays.sort((a, b) => {
  //       //     const dayOrder = days.map(d => d.day);
  //       //     return dayOrder.indexOf(a.day) - dayOrder.indexOf(b.day);
  //       //   });
  //       // });
  //       setScheduleDays(prev=>[newItem])
  //       console.log(scheduleDays);

  //     }

  //   }

  // }

  const handleDayClick = (day) => {
    // console.log(day,"icecrea,e");

    setMyDay(day);
    setScheduleDays(days.filter((item) => item.day === day))
  }

  if (!schedule) {
    return (
      // <div className="loader-container">
      //     <div className="dot-wave-loader">
      //         <div></div>
      //         <div></div>
      //         <div></div>
      //         <div></div>
      //         <div></div>
      //     </div>
      // </div>
      <>
        <div className='layout3-div'>
          <div className='shimmer-schedule-for-laptop'>
            <div className='Events-main-div'>
              <div className='Events-main-inner-div'>
                <MdOutlineWidgets style={{ fontSize: "25px" }} />
                <div className='All-days'>
                  {/* <ShimmerThumbnail height={35} rounded />
          <ShimmerThumbnail height={35} rounded />
          <ShimmerThumbnail height={35} rounded />
          <ShimmerThumbnail height={35} rounded />
          <ShimmerThumbnail height={35} rounded />
          <ShimmerThumbnail height={35} rounded />
          <ShimmerThumbnail height={35} rounded /> */}
                  <div className='day'>
                    <p>&nbsp; &nbsp;</p>
                    {/* <ShimmerButton size="md" /> */}
                  </div>
                  <div className='day'>
                    <p>&nbsp; &nbsp;</p>
                    {/* <ShimmerButton size="md" /> */}
                  </div>
                  <div className='day'>
                    <p>&nbsp; &nbsp;</p>
                    {/* <ShimmerButton size="md" /> */}
                  </div>
                  <div className='day'>
                    <p>&nbsp; &nbsp;</p>
                    {/* <ShimmerButton size="md" /> */}
                  </div>
                  <div className='day'>
                    <p>&nbsp; &nbsp;</p>
                    {/* <ShimmerButton size="md" /> */}
                  </div>
                  <div className='day'>
                    <p>&nbsp; &nbsp;</p>
                    {/* <ShimmerButton size="md" /> */}
                  </div>
                  <div className='day'>
                    <p>&nbsp; &nbsp;</p>
                    {/* <ShimmerButton size="md" /> */}
                  </div>


                </div>
                <div></div>
              </div>
              <div className='Events-main-all-content-outer-div'>
                <div className='Events-main-all-content-main-outer-div-for-all-day'>
                  <div className='Events-main-all-content-inner-div'>
                    {/* <div className='Events-main-all-content-para-div1234567890'>
                      <ShimmerText line={3} gap={10} />
                    </div> */}
                    <ShimmerThumbnail height={250} />
                  </div>
                  <div className='Events-main-all-content-inner-div'>
                    {/* <div className='Events-main-all-content-para-div1234567890'>
                      <ShimmerText line={3} gap={10} />
                    </div> */}
                    <ShimmerThumbnail height={250} />
                  </div>
                  <div className='Events-main-all-content-inner-div'>
                    {/* <div className='Events-main-all-content-para-div1234567890'>
                      <ShimmerText line={3} gap={10} />
                    </div> */}
                    <ShimmerThumbnail height={250} />
                  </div>
                  <div className='Events-main-all-content-inner-div'>
                    {/* <div className='Events-main-all-content-para-div1234567890'>
                      <ShimmerText line={3} gap={10} />
                    </div> */}
                    <ShimmerThumbnail height={250} />
                  </div>
                  <div className='Events-main-all-content-inner-div'>
                    {/* <div className='Events-main-all-content-para-div1234567890'>
                      <ShimmerText line={3} gap={10} />
                    </div> */}
                    <ShimmerThumbnail height={250} />
                  </div>
                  {/* <div className='Events-main-all-content-inner-div'>
        <div className='Events-main-all-content-para-div1234567890'>
          <ShimmerText line={3} gap={10} />
        </div>
          <ShimmerThumbnail height={250}/>
      </div> */}


                  {/* <div style={{width:"350px",marginBottom:"10px"}}><ShimmerPostItem card text imageType="thumbnail" /></div>
    <div style={{width:"350px",marginBottom:"10px"}}><ShimmerPostItem card text imageType="thumbnail" /></div>
    <div style={{width:"350px",marginBottom:"10px"}}><ShimmerPostItem card text imageType="thumbnail" /></div>
    <div style={{width:"350px",marginBottom:"10px"}}><ShimmerPostItem card text imageType="thumbnail" /></div>
    <div style={{width:"350px",marginBottom:"10px"}}><ShimmerPostItem card text imageType="thumbnail" /></div>
    <div style={{width:"350px",marginBottom:"10px"}}><ShimmerPostItem card text imageType="thumbnail" /></div> */}
                </div>
              </div>

            </div>
          </div>
          <div className='shimmer-schedule-for-mobile'>
            <div className='Events-main-div'>
              <div className='Events-main-inner-div'>
                <MdOutlineWidgets style={{ fontSize: "25px", marginBottom: "20px" }} />
                <div className='All-days'>
                  <ShimmerThumbnail height={35} rounded />
                  <ShimmerThumbnail height={35} rounded />
                  <ShimmerThumbnail height={35} rounded />
                  <ShimmerThumbnail height={35} rounded />
                  <ShimmerThumbnail height={35} rounded />
                  <ShimmerThumbnail height={35} rounded />
                  <ShimmerThumbnail height={35} rounded />

                </div>
                <div></div>
              </div>
              <div className='Events-main-all-content-outer-div'>
                <div className='Events-main-all-content-main-outer-div-for-all-day'>
                  <div style={{ width: "350px", marginBottom: "10px" }}><ShimmerPostItem text /></div>
                  <div style={{ width: "350px", marginBottom: "10px" }}><ShimmerPostItem text /></div>
                  <div style={{ width: "350px", marginBottom: "10px" }}><ShimmerPostItem text /></div>
                  <div style={{ width: "350px", marginBottom: "10px" }}><ShimmerPostItem text /></div>
                  <div style={{ width: "350px", marginBottom: "10px" }}><ShimmerPostItem text /></div>
                  {/* <div style={{width:"350px",marginBottom:"10px"}}><ShimmerPostItem text /></div> */}
                </div>
              </div>

            </div>
          </div>
        </div>

      </>
    );
  }

  if (error) {
    return (
      <>
        <div className="blur-background"></div>
        <div className="error-container">
          <p>{error}</p>
        </div>
      </>
    )
  }

  return (
    <div className='layout3-div'>
      <div className='Events-main-div'>
        <div className='Events-main-inner-div'>
          <MdOutlineWidgets style={{ fontSize: "25px" }} />
          <div className='All-days'>
            {days.map((item) => (
              <p
                className={`day ${scheduleDays.find(dayItem => dayItem.day == item.day) ? 'redss' : ''}`}
                key={item.id}
                // style={{ backgroundColor: scheduleDays.includes(item.day) ? '#D9EE15' : '#635F68' }}
                onClick={() => handleDayClick(item.day)}
              >
                {item.day.slice(0, 2)}
              </p>
            ))}
          </div>
          <div></div>

        </div>
        <div className='Events-main-all-content-outer-div'>
          {/* {days.map((item) => ( */}
          {schedule ?
            <>
              <div className='Events-main-all-content-main-outer-div-for-all-day' >
                {/* {console.log(schedule)} */}
                
                {schedule.map(item => (
                  <div className='Events-main-all-content-inner-div' key={item.id}>
                    <div style={{backgroundColor:item.id==matchl?"#ff00000f":"transparent"}} className='Events-main-all-content-para-div1'>
                      <div className='Events-main-all-content-para-div'>
                        <p className='Events-timing'>{item.time}</p>
                        <p className='events-heading'>{item.title}</p>
                        <p className='Events-heading-created-by'>{item.host}</p>
                      </div>

                    </div>
                    <div className='Events-image-dic' style={{background: item.id == matchl
    ? `linear-gradient(rgba(0, 0, 0, 0), rgba(167, 15, 15, 0.77)), url(${item.image})`
    : `linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.3)), url(${item.image})`
}}>
                      <div className='Events-image-dic-inner'>
                     <div style={{display:"flex",justifyContent:"end"}}>{item.id==matchl?<div className='Event-live'><span style={{paddingRight:"10px"}}>ON AIR</span>   <div class="Event-live-animation">
    <span></span>
    <span></span>
    <span></span>
    {/* <span></span> */}
    {/* <span></span> */}
  </div></div>:""}</div>
                     <div> {/* <div className='Events-image-dic-inner1'> */}

<p className='Events-timing'>{item.time}</p>
  <p className='events-heading'>{item.title}</p>
  <p className='Events-heading-created-by'>{item.host}</p>
{/* </div> */}</div>
                      </div>
                      {/* <img src={item.image} alt={item.title} /> */}
                    </div>
                    
                  </div>

                ))}
              </div>
            </> : <div>Data not Found</div>}
          {/* {} <div key={item.id} style={{ height: '77px',marginTop:"15px" }}></div> */}
          {/* ))} */}
        </div>
      </div>
    </div>
  )
}

export default Schedule